import { DEFAULT_FONT_FAMILY } from '@vimily/bonjoro-ui-components-v2/PublishableEmbed';
import createPersistedState from '~/react-hooks/use-persisted-state';
const previousFontFamilyHook = createPersistedState('previous-font-family');

export interface PreviousFontFamilyHookProps {
  value: string;
  setValue: (value: string) => void;
}

export function usePreviousFontFamily(
  defaultValue: string = DEFAULT_FONT_FAMILY
) {
  const [value, setValue] = previousFontFamilyHook<string>(defaultValue);

  return {
    value,
    setValue,
  } as PreviousFontFamilyHookProps;
}
